import { Box, Flex, FormControl, Image, Input, Stack, Tag } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC, useState } from "react"
import { File } from "src/domain/entities/file"
import { ProductCategory } from "src/domain/entities/productCategory"
import { IProductCategoryUpdateFormFields } from "."
import { fetchGujaratiSuggestions } from "../../../../utils/helpers"
import { FormikOnSubmit } from "../../../../utils/types"
import { DrawerForm, ErrorMessageField } from "../../../ui"
import { InputLabel } from "../../../ui/InputLabel"

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	productCategory: ProductCategory
	handleSubmit: FormikOnSubmit<IProductCategoryUpdateFormFields>
	parentProductCategoryList: ProductCategory[]
	handleUploadImage: (file: any) => void
	selectedImage?: File
}

export const ProductCategoryUpdateDrawerFormView: FC<Props> = ({
	productCategory,
	handleSubmit,
	parentProductCategoryList,
	handleUploadImage,
	selectedImage,
	...rest
}) => {
	const [nameSuggestions, setNameSuggestions] = useState<string[]>([])

	return (
		<Formik<IProductCategoryUpdateFormFields>
			initialValues={{
				name: productCategory.name,
			}}
			onSubmit={handleSubmit}
			enableReinitialize={true}
		>
			{({ values, isSubmitting, handleChange, setFieldValue }) => {
				const handleNameChange = async (
					e: React.ChangeEvent<HTMLInputElement>,
				) => {
					setFieldValue("name.en", e.target.value)
					const suggestions = await fetchGujaratiSuggestions(e.target.value)
					setNameSuggestions(suggestions)
				}

				return (
					<DrawerForm
						size="sm"
						headerLabel="Update Product Category"
						submitLabel="Save"
						isSubmitting={isSubmitting}
						{...rest}
					>
						<Stack maxWidth={"sm"} marginX={"auto"}>
							<Flex gridGap={2}>
								<Box>
									{/* Name */}
									<FormControl>
										<InputLabel label="Name" />
										<Input
											name="name.en"
											placeholder="Name"
											maxLength={50}
											required
											autoFocus
											value={values.name?.en}
											onChange={handleNameChange}
										/>
										<ErrorMessage
											component={ErrorMessageField}
											name="name.en"
										/>
									</FormControl>
									<Box>
										{nameSuggestions.map((el, i) => (
											<Tag
												colorScheme={"green"}
												backgroundColor={"green.50"}
												variant="outline"
												_hover={{
													backgroundColor: "green.100",
												}}
												cursor="pointer"
												margin={0.5}
												onClick={() => {
													setFieldValue("name.gu", el)
													setNameSuggestions([])
												}}
												key={i}
											>
												{el}
											</Tag>
										))}
									</Box>
								</Box>

								{/* Name Gu */}
								<FormControl>
									<InputLabel label="Name Gujarati" />
									<Input
										name="name.gu"
										placeholder="Name Gujarati"
										maxLength={50}
										required
										value={values.name?.gu}
										onChange={handleChange}
									/>
									<ErrorMessage
										component={ErrorMessageField}
										name="name.gu"
									/>
								</FormControl>
							</Flex>
							<Stack maxWidth={"sm"} marginX={"auto"}>
								{/* Image file */}
								<FormControl flex={2}>
									<InputLabel label="Image file" />
									<Input
										name="imageFile"
										type="file"
										onChange={(e) => {
											if (!e.target.files?.[0]) return
											handleUploadImage(e.target.files?.[0])
										}}
									/>
								</FormControl>
								{/* Image preview */}
								{selectedImage ? (
									<Box>
										<Image
											src={selectedImage?.variants?.[0]}
											alt="Image preview"
											width="100%"
											height="auto"
											objectFit="cover"
											borderRadius="lg"
										/>
									</Box>
								) : null}
							</Stack>
						</Stack>
					</DrawerForm>
				)
			}}
		</Formik>
	)
}
